const green = '#00B061';
const mossGreen = '#99f2bd';
const tetherGreen = '#4d9a79';
const red = '#F0162F';
const orange = '#f08416';
const bitcoinOrange = '#e9973d';
const blue = '#0000FF';
const ligthBlue = '#87CEFA';
const white = 'white';
const black = 'black';
const gray = '#808080';
const gold = '#FFC700';
const purple = '#9400D3';
const lightRed = '#F5C2C1';
const pink = '#FF69B4';
const cyan = '#008B8B';
const darkGreen = '#004526';
const yellow = '#FFFF00';

type Colors = {
  green: '#00B061';
  mossGreen: '#99f2bd';
  tetherGreen: '#4d9a79';
  red: '#F0162F';
  lightRed: '#F5C2C1';
  orange: '#f08416';
  bitcoinOrange: '#e9973d';
  blue: '#0000FF';
  ligthBlue: '#87CEFA';
  white: 'white';
  black: 'black';
  gray: '#808080';
  gold: '#FFC700';
  purple: '#9400D3';
  pink: '#FF69B4';
  cyan: '#008B8B';
  darkGreen: '#004526';
  yellow: '#FFFF00';
};

export const colors: Colors = {
  green,
  mossGreen,
  tetherGreen,
  red,
  orange,
  bitcoinOrange,
  blue,
  ligthBlue,
  white,
  black,
  gray,
  gold,
  purple,
  lightRed,
  pink,
  cyan,
  darkGreen,
  yellow,
};

export const movingAverageColors = [colors.red, colors.green];

export const movingAverageWaverColors = [
  colors.orange,
  colors.pink,
  colors.purple,
  colors.blue,
  colors.gold,
  colors.mossGreen,
  colors.gray,
  colors.white,
];
